import { useState } from "react";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export function ImageField({ value, onChange, testid = "image-field" }) {
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/admin/upload", fd);
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  return (
    <div className="space-y-3">
      {value && <img src={value} alt="" className="h-36 w-auto border border-ash bg-white object-contain p-1" />}
      <input
        data-testid={`${testid}-url-input`}
        className="field"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Paste an image URL or upload below"
      />
      <label className="inline-flex cursor-pointer items-center gap-2 border border-obsidian/20 px-4 py-2 text-[12px] font-bold uppercase tracking-[0.14em] hover:border-progress hover:text-progress">
        <Upload size={13} /> {busy ? "Uploading…" : "Upload image"}
        <input data-testid={`${testid}-upload-input`} type="file" accept="image/*" hidden onChange={upload} />
      </label>
    </div>
  );
}

export default ImageField;
